module.exports = __webpack_public_path__ + "img/bubble_layout_4.4a67e360.png";